export const PRICE = '23 USD'

export const BRAND = 'Lash & Brow Instructor Ready™'

/** Interior pages from Volume 5, in the required order. Real pages are 1080×1350. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/mosP943buPCABpt1pTdNKP/01_pagina_13_brow_mapping_symmetry.webp',
    caption: 'Volume 5 — Page 13',
    label: 'Brow Mapping & Symmetry',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aBMnnmide1fKucWCXUn16B/02_pagina_32_lash_mapping_styles.webp',
    caption: 'Volume 5 — Page 32',
    label: 'Lash Mapping Styles',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jEsD5KoPLG82GdPbLyjrh9/03_pagina_33_lash_mapping_correction.webp',
    caption: 'Volume 5 — Page 33',
    label: 'Lash Mapping Correction',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/67EU6eSJFzfr1GCTizasV3/04_pagina_22_brow_color_matching.webp',
    caption: 'Volume 5 — Page 22',
    label: 'Brow Color Matching',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6XvQDLH9HPjvsfHrS5Qnex/05_pagina_38_lash_lift_shields.webp',
    caption: 'Volume 5 — Page 38',
    label: 'Lash Lift Shields',
  },
]

export const painPoints = [
  {
    title: 'Endless Lesson Planning',
    text: 'Spending evenings organizing what to teach next.',
  },
  {
    title: 'Scattered Teaching Materials',
    text: 'Searching through notes, documents, and disconnected resources.',
  },
  {
    title: 'Last-Minute Student Exercises',
    text: 'Creating activities and practice sheets before every class.',
  },
  {
    title: 'Assessments From Scratch',
    text: 'Trying to build professional evaluation tools without a clear system.',
  },
]

export const solutionBenefits = [
  { title: 'Structured Lesson Plans', text: 'A clear sequence for every class you teach.', tint: '#F6DDD8' },
  { title: 'Professional Technique Guides', text: 'Lash and brow techniques broken into teachable steps.', tint: '#D9EAF8' },
  { title: 'Student Practice Resources', text: 'Exercises and worksheets ready to hand out.', tint: '#DCEFE6' },
  { title: 'Visual Mapping References', text: 'Brow and lash maps to explain shape and symmetry.', tint: '#EADCF5' },
  { title: 'Assessment & Feedback Tools', text: 'Rubrics and evaluations to track student progress.', tint: '#F5E3B8' },
  { title: 'Classroom Teaching Materials', text: 'Visuals and talking points for live demonstrations.', tint: '#F6DDD8' },
]

/** Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'The Complete Lash & Brow Instructor System',
    description: 'Professional education foundations & course planning.',
    accent: '#F6D3D0',
  },
  {
    number: 2,
    title: 'Professional Brow Techniques & Teaching Guide',
    description: 'Mapping, shaping, tinting, henna & lamination.',
    accent: '#F7D6CF',
  },
  {
    number: 3,
    title: 'Professional Lash Techniques & Teaching Guide',
    description: 'Extensions, lash mapping, lash lift & tinting.',
    accent: '#D9EAF8',
  },
  {
    number: 4,
    title: 'The Ready-to-Teach Lash & Brow Lesson Library',
    description: 'Complete lesson plans, teaching scripts & demonstrations.',
    accent: '#DCEFE6',
  },
  {
    number: 5,
    title: 'The Lash & Brow Student Practice Workbook',
    description: 'Hands-on exercises, mapping sheets & skill development.',
    accent: '#EADCF5',
  },
  {
    number: 6,
    title: 'The Lash & Brow Student Assessment & Certification Toolkit',
    description: 'Exams, practical evaluations, rubrics & student progress tools.',
    accent: '#F5E3B8',
  },
]

export const bonuses = [
  {
    number: 'Bonus 1',
    title: 'The Ultimate Lash & Brow Visual Teaching Atlas™',
    description: 'Mapping charts, diagrams, and classroom visuals.',
    accent: '#F6DDD8',
  },
  {
    number: 'Bonus 2',
    title: 'The Lash & Brow Client Forms & Aftercare Library™',
    description: 'Consultation, client documentation, and aftercare resources.',
    accent: '#DCEFE6',
  },
  {
    number: 'Bonus 3',
    title: 'The Advanced Lash & Brow Case Study Vault™',
    description: 'Realistic scenarios, troubleshooting, and instructor solutions.',
    accent: '#D9EAF8',
  },
  {
    number: 'Bonus 4',
    title: 'The Lash & Brow Student Handbook Collection™',
    description: 'Ready-to-use technical reference guides for students.',
    accent: '#EADCF5',
  },
  {
    number: 'Bonus 5',
    title: 'The Lash & Brow Classroom Presentation Vault™',
    description: 'Visual lessons, presentation materials, and instructor talking points.',
    accent: '#F5E3B8',
  },
]

export const beforeItems = [
  'Planning lessons from scratch',
  'Searching through scattered files',
  'Creating student activities manually',
  'Building evaluations at the last minute',
  'Repeating the same preparation work',
]

export const afterItems = [
  'Structured lesson resources',
  'Organized professional guides',
  'Prepared student practice materials',
  'Assessment and feedback tools',
  'A reusable teaching library',
]

export const audience = [
  'Lash Extension Instructors',
  'Brow Educators',
  'Beauty Academy Owners',
  'Lash & Brow Trainers',
]

export const offerIncludes = [
  '6 Professional Digital Volumes',
  '5 Practical Bonuses',
  'Instant Digital Access',
  'PDF Resources for Teaching Preparation',
]

export const faqs = [
  {
    question: 'Is this for beginners?',
    answer:
      'This system is designed for lash and brow educators and professionals preparing to teach. It does not replace foundational technical training.',
  },
  {
    question: 'What will I receive?',
    answer: 'Six professional digital volumes and five practical bonus resources in PDF format.',
  },
  {
    question: 'Can I use the resources for my classes?',
    answer:
      'The materials are designed to support lesson preparation, demonstrations, student activities, and evaluations. Usage and redistribution rights must follow the applicable product license.',
  },
  {
    question: 'Are the PDFs editable?',
    answer: 'No. They are professionally designed, non-editable PDF resources.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. This is a digital product.',
  },
  {
    question: 'Does this provide official certification?',
    answer:
      'No. It includes course-completion assessment resources, not official accreditation or professional licensing.',
  },
  {
    question: 'Can I use it for both lashes and brows?',
    answer: 'Yes. The system covers both specialties.',
  },
  {
    question: 'Is the payment secure?',
    answer:
      'Yes. Checkout is secure and encrypted, and your payment is processed automatically in your local currency.',
  },
  {
    question: 'How do I access my purchase?',
    answer: 'Digital access instructions are provided through the checkout and delivery process.',
  },
]
